import {Sprite} from 'pixi.js';
import {
    KeypadInfoElementsViewMobileLandscape
} from '@gongxigames/framework/slot/modules/keypadInfo/KeypadInfoElementsViewMobileLandscape';
import {KeypadView, KeypadViewMobilePortrait} from '@gongxigames/framework/slot/modules/keypad';

export class KeypadInfoElementsViewMobilePortrait extends KeypadInfoElementsViewMobileLandscape {
    public static readonly NAME: symbol = Symbol('KeypadInfoElementsViewMobilePortrait');

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadViewMobilePortrait.NAME).mainSprite;
    }

    public getViewDependencies(): (symbol|string)[] {
        return [KeypadViewMobilePortrait.NAME];
    }
}
